import React from "react";
import SectionContainer from "../shared/SectionContainer";
import SectionTitle from "../shared/SectionTitle";
import "./IconGrid.css";

export type IconGridItem = {
  title: string;
  description?: string;

  /** Simple emoji or inline SVG node; keep it minimal and consistent. */
  icon?: React.ReactNode;
};

type IconGridProps = {
  id?: string;

  title: string;
  subtitle?: string;

  items: IconGridItem[];

  /** 2–4 columns depending on density */
  columns?: 2 | 3 | 4;

  /** Wrap in a card surface (default true) */
  card?: boolean;
};

function cls(...parts: Array<string | false | null | undefined>) {
  return parts.filter(Boolean).join(" ");
}

const IconGrid: React.FC<IconGridProps> = ({
  id,
  title,
  subtitle,
  items,
  columns = 4,
  card = true,
}) => {
  return (
    <SectionContainer id={id} card={card}>
      <SectionTitle title={title} subtitle={subtitle} />
      <div className={cls("ocf-pi-ig", `ocf-pi-ig--cols-${columns}`)}>
        {items.map((it, idx) => (
          <div key={`${it.title}-${idx}`} className="ocf-pi-ig-item">
            <div className="ocf-pi-ig-icon" aria-hidden>
              {it.icon ?? "•"}
            </div>
            <div className="ocf-pi-ig-body">
              <div className="ocf-pi-ig-title">{it.title}</div>
              {it.description && (
                <div className="ocf-pi-ig-desc">{it.description}</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </SectionContainer>
  );
};

export default IconGrid;
